import React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { grFieldSx } from "src/design-system/components/GrTextField";

// Date range fields of the Videos Library and the weekly chart (inside GrFilterDrawer): start, end.
export default function VideoFilter({ filterData, handleSelectOther }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label="Start date"
        name="start"
        inputFormat="dd-MM-yyyy"
        value={filterData.start}
        onChange={(newValue) => {
          handleSelectOther("start", newValue);
        }}
        renderInput={(params) => (
          <TextField {...params} required fullWidth sx={grFieldSx} />
        )}
      />
      <DatePicker
        label="End date"
        name="end"
        inputFormat="dd-MM-yyyy"
        value={filterData.end}
        onChange={(newValue) => {
          handleSelectOther("end", newValue);
        }}
        renderInput={(params) => (
          <TextField {...params} required fullWidth sx={grFieldSx} />
        )}
      />
    </LocalizationProvider>
  );
}
